export const createFieldToEntityMap = (entities, field) => {
  const entityMap = entities.reduce((map, entity) => {
    map[String(entity[field])] = entity;
    return map;
  }, {});
  return entityMap;
};
export const isEmpty = obj => {
  if (obj === null) {
    return true;
  }
  return Object.keys(obj).length === 0;
};
export const sum = (a, b) => {
  return (a || 0) + (b || 0);
};
export const concat = (a, b) => {
  return [...(a || []), ...(b || [])];
};
//# sourceMappingURL=common.js.map